import { render, staticRenderFns } from "./TextPage.vue?vue&type=template&id=b9a500cc&scoped=true&"
import script from "./TextPage.vue?vue&type=script&lang=js&"
export * from "./TextPage.vue?vue&type=script&lang=js&"
import style0 from "./TextPage.vue?vue&type=style&index=0&id=b9a500cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a500cc",
  null
  
)

export default component.exports